module.exports = __webpack_public_path__ + "img/grid-sample2.5a612aea.jpg";